import React, { useContext, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tools from "./JNSTools";
import DashboardTasks from "./DashboardTasks_sfgrid";
import { CredsContext } from "./Contexts";

function DashboardTasksContainer(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const projectId = useRef(projectObject.id);
  const useThisData = useRef();
  const [dataArray, setDataArray] = useState();
  const finished = useRef(false);

  const DAYS_OUT = 14;
  let initiateWait = false;
  const currentDate = new Date();
  const lastDayToInclude = new Date(
    currentDate.getTime() + DAYS_OUT * 1000 * 60 * 60 * 24,
  );

  const storedTasks = sessionStorage.getItem("dashboardTaskList");

  useEffect(() => {
    if (!storedTasks) {
      const authString = Tools.getXmlBodyAuthString(creds);
      const urlString = Tools.getInstanceUrl(creds);
      const requestString =
        authString +
        '<Read type="Projecttask" method="equal to" filter="older-than" field="calculated_starts" enable_custom="1" limit="1000"><Projecttask><projectid>' +
        projectId.current +
        "</projectid><oada_exclude_from_analysis__c></oada_exclude_from_analysis__c></Projecttask>" +
        Tools.parseDateObject(lastDayToInclude) +
        "<_Return><id/><name/><calculated_starts/><oada_exclude_from_analysis__c/><calculated_finishes/><is_a_phase/><planned_hours/><percent_complete/><notes/></_Return></Read></request>";

      Tools.fetchPost(requestString, urlString, "Projecttask").then(
        (taskResponse) => {
          let tempDataArray = [];
          if (taskResponse.xml.length > 0) {
            const initialTaskArray = Tools.xmlToArray(taskResponse.xml);
            const taskArray = initialTaskArray.filter(
              (task) =>
                task.is_a_phase != 1 &&
                task.percent_complete != 100 &&
                task.closed != 1,
            );

            for (let x = 0; x < taskArray.length; x++) {
              taskArray[x].reformattedEndDate =
                taskArray[x].calculated_finishes.substring(4, 8) +
                "-" +
                taskArray[x].calculated_finishes.substring(0, 2) +
                "-" +
                taskArray[x].calculated_finishes.substring(2, 4);

              taskArray[x].reformattedStartDate =
                taskArray[x].calculated_starts.substring(4, 8) +
                "-" +
                taskArray[x].calculated_starts.substring(0, 2) +
                "-" +
                taskArray[x].calculated_starts.substring(2, 4);
            }
            taskArray.sort(
              (a, b) =>
                new Date(a.reformattedEndDate) - new Date(b.reformattedEndDate),
            );

            taskArray.forEach((elem) => {
              if (elem.oada_exclude_from_analysis__c != "1") {
                tempDataArray.push({
                  name: elem.name,
                  start: elem.reformattedStartDate,
                  end: elem.reformattedEndDate,
                  pct: elem.percent_complete || 0,
                });
              }
            });
            useThisData.current = tempDataArray;
          }
          finished.current = true;
          sessionStorage.setItem(
            "dashboardTaskList",
            JSON.stringify(tempDataArray),
          );
          setDataArray(tempDataArray);
        },
      );
    } else {
      finished.current = true;
      const storedTasksArray = JSON.parse(storedTasks);
      useThisData.current = storedTasksArray;
      setDataArray(storedTasksArray);
    }
  }, []);
  return (
    <DashboardTasks
      dataArray={useThisData.current}
      panelLocked={props.panelLocked}
      removePanel={props.removePanel}
      panelId={props.panelId}
      finished={finished.current}
      initiateWait={initiateWait}
      statusVersion={props.statusVersion}
    ></DashboardTasks>
  );
}

export default DashboardTasksContainer;

DashboardTasksContainer.propTypes = {
  inPanel: PropTypes.bool,
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
  statusVersion: PropTypes.bool,
};
